<template>
  <div class="app-body">
    <el-form :inline="true" class="query-form" :model="dataForm" @keyup.enter.native="$refs.table.reload()">
      <el-form-item label="外销合同号：">
        <el-input v-model="dataForm.orderCode" size="mini" placeholder="请输入外销合同号" clearable></el-input>
      </el-form-item>
      <el-form-item label="费用名称：">
        <el-input v-model="dataForm.name" size="mini" placeholder="请输入费用名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="开票方：">
        <el-input v-model="dataForm.sellerReceiptName" size="mini" placeholder="请输入开票方" clearable></el-input>
      </el-form-item>
      <el-form-item label="发票号：">
        <el-input v-model="dataForm.receiptCode" size="mini" placeholder="请输入发票号" clearable></el-input>
      </el-form-item>
      <el-form-item label="车间/部门：">
        <el-input v-model="dataForm.dept" size="mini" placeholder="请输入车间/部门" clearable></el-input>
      </el-form-item>
      <el-form-item label="费用时间：">
        <el-date-picker
            v-model="operateTime"
            type="daterange"
            size="mini"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="制单时间：">
        <el-date-picker
            v-model="createTime"
            type="daterange"
            size="mini"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="$refs.table.reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$hasPermission('trade:cost:save')" type="primary" @click="addOrUpdateHandle()" size="mini">
          {{ $t('add') }}
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" v-if="$hasPermission('trade:cost:save')" type="warning" @click="$refs.uploader.init()">
          费用导入
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$hasPermission('cost:export')" @click="$refs.table.export('费用')" size="mini" type="warning">导出EXCEL</el-button>
      </el-form-item>
    </el-form>
    <SweetTable url="/erp/cost/page" ref="table" delete-url="/erp/cost" :query-form="dataForm" api-version="v2">
      <el-table-column prop="orderCode" label="外销合同号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="name" label="费用名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="count" label="数量" width="120" header-align="center" align="center"></el-table-column>
      <el-table-column prop="amount" label="金额" width="120" header-align="center" align="center"></el-table-column>
      <el-table-column prop="sellerReceiptName" label="开票方" header-align="center" align="center"></el-table-column>
      <el-table-column prop="receiptCode" label="发票号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="dept" label="部门/车间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="operateTime" width="120" label="费用时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createDate" width="160" label="制单时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="creatorName" width="80" label="制单人" header-align="center" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="90">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('trade:cost:update')" type="text" size="small"
                     @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
          </el-button>
          <el-button v-if="$hasPermission('trade:cost:delete')" type="text" size="small"
                     @click="$refs.table.doDelete(scope.row)">{{ $t('delete') }}
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="$refs.table.getDataList"></add-or-update>
    <common-upload
        ref="uploader"
        @success="$refs.table.getDataList()"
        uploadUrl="/trade/cost/import"
        templateUrl="/static/template/费用导入模板.xlsx"
        title="费用导入"
    ></common-upload>
  </div>
</template>

<script>
import AddOrUpdate from './save'
import SweetTable from '@/mixins/SweetTable'
export default {
  mixins: [SweetTable],
  data () {
    return {
      operateTime:[],
      createTime:[],
      dataForm: {
        name: '',
        orderCode: '',
        sellerReceiptName: '',
        receiptCode: '',
        dept: '',
        operateTimeStart: '',
        operateTimeEnd: '',
        createTimeStart: '',
        createTimeEnd: '',
      },
    }
  },
  watch:{
    operateTime:{
      handler(val){
        if(this.$c.isArrayEmpty(val)){
          this.dataForm.operateTimeStart = ''
          this.dataForm.operateTimeEnd = ''
        }else{
          this.dataForm.operateTimeStart = val[0]
          this.dataForm.operateTimeEnd = val[1]
        }
      },
      deep:true
    },
    createTime:{
      handler(val){
        if(this.$c.isArrayEmpty(val)){
          this.dataForm.createTimeStart = ''
          this.dataForm.createTimeEnd = ''
        }else{
          this.dataForm.createTimeStart = val[0]
          this.dataForm.createTimeEnd = val[1]
        }
      },
      deep:true
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
